"use strict";

module.exports = {
    WALKING: '0',
    FLYING: '1',
    BUS: '2',
    DRIVING: '3',
    PUBLIC: '4',
};



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/utils/travel.js
 ** module id = 243
 ** module chunks = 0 1 6 9
 **/